import { z } from 'zod';
import { uuid } from './primitives.js';
/**
 * Nur Referenzmodell. Das Geo-Schema von vMaps wird in einer eigenen Phase
 * gebaut; hier existiert ausschliesslich die Verknuepfbarkeit.
 */
export const vmapsLinkSourceSchema = z.enum([
    'trophy',
    'roadmap_step',
    'completion_item',
    'completion_category',
]);
export const vmapsLinkSchema = z.object({
    id: uuid,
    sourceType: vmapsLinkSourceSchema,
    sourceId: uuid,
    gameId: uuid,
    /** Opaque Kennung im vMaps-Projekt. PlatHunt interpretiert sie nicht. */
    vmapsTargetId: z.string().min(1),
    label: z.string().nullable(),
});
//# sourceMappingURL=vmaps.js.map